import React, { useState, useEffect } from "react";

interface SteamApp {
  appid: number;
  name: string;
}

interface SteamAppListProps {
  searchPhrase: string;
  onHover: (id: number | null) => void;
}

export const SteamAppList: React.FC<SteamAppListProps> = (props) => {
  const [apps, setApps] = useState<SteamApp[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    fetchSteamAppList(props.searchPhrase)
      .then(setApps)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [props.searchPhrase]);

  if (loading) return <p>Loading Steam App list...</p>;
  if (error) return <p>Error: {error}</p>;
  
  return (
    <div className="appList">
      <h2>Steam library</h2>
      <div>Showing {apps.length} items</div>
      <ul>
          {apps.map((app) => (
            <li key={app.appid} onMouseEnter={() => props.onHover(app.appid)}>
                <a href={"https://store.steampowered.com/app/" + app.appid}>
                  {app.name}
                </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

async function fetchSteamAppList(
  searchPhrase = ""
): Promise<SteamApp[]> {
  if(searchPhrase.length < 2){
    return [];
  }
  const url = "https://steamapi.wglnd.workers.dev/?q=" + searchPhrase;
  const resp = await fetch(url);
  if (!resp.ok) {
    throw new Error(`HTTP error ${resp.status}`);
  }
  const data: SteamApp[] = await resp.json();
  return data;
}
